import { findOptions } from "../../../../../helpers/StringHelper";

export const mapEvents = (data, options, view = '') => {
  const {
    countryOptions = [],
    testimonialsType = [],
    categoryOptions: _categoryOptions = [],
  } = options || {};

  const categoryOptions = view === 'incidents' ?
    _categoryOptions.map((c) => ({ ...c, label: c.label['typeOfEvent is incident'] }))
    : _categoryOptions.map((c) => ({ ...c, label: c.label['typeOfEvent is correctiveActions'] }))

  return data.map(event => {
    const author = event.authorId ? event.authorId.name : '';
    const level1 = (event?.linking?.SCL || {})[event.location?.administrativeLevel1];
    const level2 = (event?.linking?.SCL || {})[event.location?.administrativeLevel2];

    return {
      id: event.datastakeId ? event.datastakeId : '--',
      author,
      testimonialsSource: event.testimonialsSource,
      eventTitle: event && event.name ? event.name : '--',
      typeOfEvent: event && event.type
        ? findOptions(event.type, testimonialsType) : '--',
      location: event.location?.name || '--',
      country: event && event.country
        ? findOptions(event.country, countryOptions) : '--',
      category: findOptions(event.eventCategory, categoryOptions),
      province: level1?.name || '--',
      status: event.published ? 'submitted' : undefined,
      source: event?.authorId?.name || '--',
      territory: level2?.name || '--',
      dateOfEvent: event.date,
      version: event.version,
      dbId: event.id,
      updatedAt: event.updatedAt,
    };
  })
}

export const getEventFilterOptions = (options, view) => {
  const {
    associatedRiskOptions = [],
    countries = [],
    testimonialsType = [],
    typeOfEventOptions = [],
    administrativeLevel1,
    administrativeLevel2,
    categoryOptions = [],
  } = options || {};

  const _default = {
    associatedRisk: associatedRiskOptions,
    country: countries,
    typeOfEvent: typeOfEventOptions,
    administrativeLevel1,
    type: view === 'testimonials' ? testimonialsType : undefined,
    administrativeLevel2,
    eventCategory: view === 'testimonials' ? undefined : view === 'incidents' ?
      categoryOptions.map((c) => ({ ...c, label: c.label['typeOfEvent is incident'] }))
      : categoryOptions.map((c) => ({ ...c, label: c.label['typeOfEvent is correctiveActions'] }))
  }

  return _default;
}

export const filtersConfig = {
  name: '',
  datastakeId: '',
  // location: '',
  // author: '',
  // territory: '',
  // province: '',
};

export const selectFiltersConfig = {
  timeframe: {
    type: 'timeframe',
    label: 'Timeframe',
    style: { flex: 1 },
  },
  country: {
    type: 'select',
    label: 'Country',
    placeholder: (t) => t('Country'),
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  administrativeLevel1: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel1 } = options;

      if (administrativeLevel1) {
        if (options.country) {
          const _item = administrativeLevel1[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Province');
    },
    placeholder: (t) => t('Province'),
    filters: (data) => ({
      country: data.country,
      level: 'level_1',
    }),
    show: (data) => !!!data.country,
    disabled: (data) => !!!data.country,
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { flex: 1 },
  },
  administrativeLevel2: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel2 } = options;

      if (administrativeLevel2) {
        if (options.country) {
          const _item = administrativeLevel2[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Territory');
    },
    placeholder: (t) => t('Territory'),
    filters: (data) => ({
      country: data.country,
      level: 'level_2',
      administrativeLevel1: data.administrativeLevel1,
    }),
    disabled: (data) => !(data.country && data.administrativeLevel1),
    show: (data) => !(data.country && data.administrativeLevel1),
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { flex: 1 },
  },
  eventCategory: {
    type: 'select',
    label: 'Category',
    placeholder: (t) => t('Category'),
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  type: {
    type: 'select',
    label: 'Type',
    placeholder: (t) => t('Type'),
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  source: {
    type: 'select',
    label: 'Source',
    placeholder: (t) => t('Source'),
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
};

export const checkboxConfig = {
  name: 'Name',
  datastakeId: 'ID',
  // location: 'Location',
  // author: 'Author',
  // territory: 'Territory',
  // province: 'Province',
};

export const allStatuses = ['incident', 'riskMitigationMeasures', 'other'];

export const eventsView = 'events';
